import React from 'react';
import PropTypes from 'prop-types';

import { Typo } from 'uikit/content';

import styles from '../styles/formFieldCondition.module.scss';

const FormFieldCondition = ({ condition, hasCondition }) => {
  if (!hasCondition) return null;

  return (
    <Typo variant="s01" modifier="medium" className={styles.element}>
      {condition}
    </Typo>
  );
};

FormFieldCondition.defaultProps = {
  condition: '',
  hasCondition: false,
};

FormFieldCondition.propTypes = {
  condition: PropTypes.string,
  hasCondition: PropTypes.bool,
};

export default React.memo(FormFieldCondition);
